import BlogCard, {BlogCardAnimation} from "./blog-card";
import {useDraggable} from "react-use-draggable-scroll";
import {useEffect, useRef} from "react";
import useListApi from "../../../../hooks/useListApi";
import URLS from "../../../../API/Axios/URLS";
import {getUri} from "../../../../utils/utils";
import {useParams} from "react-router-dom";


export default function RecentBlog({className,loading, ...props}) {
    const ref = useRef(); // We will use React useRef hook to reference the wrapping div:
    const { events } = useDraggable(ref);
    const {title} = useParams();
    let [blogData, filter, isDataLoading, blogActions] = useListApi(URLS.blogsList, {
        page_size: 3,
        query: "",
        exclude: title
    });

    useEffect(() => {
        if (title) {
            blogActions.updateFilter({
                exclude: title
            })
        }

    }, [title])



    return (
        <div className={`${className} flex flex-col gap-[32px]`}>
            <p className={"text-xl font-bold"}>
                Recent Blogs
            </p>
            <div
                {...events}
                ref={ref}
                className={"flex flex-row lg:flex-col overflow-hidden  gap-[32px]"}>
                {isDataLoading && <>
                    {
                        Array(3).fill(0).map((_, index) => (
                            <BlogCardAnimation key={index} className={"w-full"}/>
                        ))
                    }
                </>
                }
                {
                    blogData?.results?.map((item, index) => {
                        return <BlogCard
                            key={index}
                            title={item?.title}
                            metaDescription={item.meta_description}
                            date={item?.updated_at}
                            thumbnail={getUri(item.thumbnail?.file)}
                        />
                    })
                }

            </div>
        </div>

    )
}